import styled from "@sonos-inc/web-ui-styled";
import css from "@sonos-inc/web-ui-css";
import { Flex } from "@sonos-inc/web-ui-flex";
export var AspectRatioBox = styled(Flex)(function (_ref) {
  var aspectRatio = _ref.aspectRatio,
      height = _ref.height,
      width = _ref.width;
  var heightPercent = 1 / (aspectRatio || 16 / 9) * 100 + "%";
  var heightString = typeof height === "number" ? height + "px" : height;
  return css({
    position: "relative",
    flexDirection: "column",
    margin: 0,
    width: width || "100%",
    height: "auto",
    "&::before": {
      content: "''",
      paddingTop: heightString ? "min(" + heightString + "," + heightPercent + ")" : heightPercent
    },
    "& > *": {
      position: "absolute",
      height: "auto",
      maxWidth: "100%"
    }
  });
});